import { CLIENT } from './getClientById';

export function getSupportedLocalesByClientId (clientId) {
    switch (clientId) {
    case CLIENT.KIBO :
        return [
            { code: 'en', name: 'English' },
            { code: 'ko', name: '한국어' },
            { code: 'ja', name: '日本語' },
            { code: 'zh-CN', name: '简体中文' }
        ];
    case CLIENT.HK_LONGMAN :
        return [
            { code: 'en', name: 'English' },
            { code: 'zh', name: '繁體中文' }
        ];
    case CLIENT.DAVIDE :
        return [
            { code: 'de', name: 'German' },
            { code: 'pl', name: 'Polish' },
            { code: 'nl', name: 'Dutch' },
            { code: 'it', name: 'Italian' },
            { code: 'es', name: 'Spanish' },
            { code: 'en', name: 'English' }
        ];
    default:
        return [
            { code: 'en', name: 'English' }
        ];
    }
}
